/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.annLocWrap = this.querySelector('.announcement__localization');
      this.localizationForm = this.annLocWrap?.querySelector('form.localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.wishlist = document.querySelector('.header__icons .th_wlc_header_icon');
      this.menu = document.querySelector('.main-menu__content');
      this.headerMenuIcons = document.querySelector('.header__icons');
      this.isPaused = false;
      this._clickBound = false;

      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
    }

    bindEvents() {
      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler || debounce(this.moveLocalization.bind(this));
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }

      if (this.slider) {
        this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
        this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
      }
    }

    /**
     * Start sliders a slidin'
     */
    init() {
      if (this.slider) {
        const slides = this.slider.querySelectorAll('.announcement__text');
        slides[0].classList.add('is-visible');

        const nextSlide = () => {
          if (!this.isPaused && window.theme.elementUtil.isInViewport(this)) {
            const currSlide = this.slider.querySelector('.announcement__text.is-visible');
            const currSlideIndex = Array.from(currSlide.parentNode.children).indexOf(currSlide);
            const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;

            if (document.dir === 'rtl') {
              this.slider.scrollTo(-Math.abs(nextSlideIndex * slides[nextSlideIndex].clientWidth), 0);
            } else {
              this.slider.scrollTo(slides[nextSlideIndex].offsetLeft - 32, 0);
            }

            slides[nextSlideIndex].classList.add('is-visible');
            slides[currSlideIndex].classList.remove('is-visible');
          }

          setTimeout(nextSlide, this.dataset.slideDelay);
        };
        setTimeout(nextSlide, this.dataset.slideDelay);
      }

      if (this.links) {
        this.moveLinks();
      }

      if (this.localizationForm) {
        this.moveLocalization();
      }
    }

    applyMobileStyles() {
      Object.assign(this.localizationForm.style, {
        display: 'none',
        position: 'fixed',
        top: '58px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '90%',
        zIndex: '9999',
        background: '#fff',
        padding: '20px',
        boxShadow: '0px 0px 12px 0px rgb(0 0 0 / 61%)',
      });
    }

    clearInlineStyles() {
      [
        'display',
        'position',
        'top',
        'left',
        'transform',
        'width',
        'zIndex',
        'background',
        'padding',
        'boxShadow',
      ].forEach((k) => this.localizationForm.style.removeProperty(k));
    }

    /**
     * Move the help links selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!window.theme.mediaMatches.md && !menuAnnouncementLinks) {
        // Move localization to mobile
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links');
        const li = document.createElement('li');
        if (this.wishlist) {
          this.wishlist.innerHTML = 'My Wishlist';
          li.appendChild(this.wishlist);
        }

        const mobNavUl = document.createElement('ul');
        mobNavUl.classList.add('secondary-nav');

        this.links.forEach((link) => {
          mobNavUl.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a></li>`;
        });

        mobNav.appendChild(mobNavUl);
        this.menu.appendChild(mobNav);
        mobNavUl.insertBefore(li, mobNavUl.firstChild);
      } else if (window.theme.mediaMatches.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    /**
     * Move the localization selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLocalization() {
      const mobileWrapper = document.querySelector('.mob__localization');
      const isDesktop = window.theme.mediaMatches.md;

      if (!isDesktop) {
        if (!mobileWrapper) {
          const wrap = document.createElement('div');
          wrap.className = 'mob__localization';
          wrap.appendChild(this.localizationForm);
          this.headerMenuIcons.appendChild(wrap);
        }
        this.applyMobileStyles();

        if (!this._clickBound) {
          const btn = document.querySelector('.m-js-country-selector-mob');
          if (btn) {
            btn.addEventListener('click', () => {
              const s = this.localizationForm.style;
              s.display = s.display === 'none' || !s.display ? 'block' : 'none';
            });
            this._clickBound = true;
          }
        }
      }

      if (isDesktop) {
        if (mobileWrapper && !this.annLocWrap.contains(this.localizationForm)) {
          this.annLocWrap.appendChild(this.localizationForm);
          mobileWrapper.remove();
        }
        this.clearInlineStyles();
      }
    }

    /**
     * Pauses the auto-rotating slider
     */
    pauseSlider() {
      this.isPaused = true;
    }

    /**
     * Resumes the auto-rotating slider
     */
    resumeSlider() {
      this.isPaused = false;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
